module.exports = __webpack_public_path__ + "static/img/1.ba2eff04.png";